// Login.jsx
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Eye, EyeOff, Mail, Lock, LogIn, ArrowRight } from 'lucide-react';
import Logo from '../components/common/Logo';

const Login = () => {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd]   = useState(false);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const { login }  = useAuth();
  const navigate   = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try { await login(email.trim(), password); navigate('/'); }
    catch { setError('Email ou mot de passe incorrect.'); }
    finally { setLoading(false); }
  };

  return (
    <div className="auth-page">
      <div className="auth-hero" style={{
        background: `
    radial-gradient(circle at 50% 30%, rgba(255, 255, 255, 0.12) 0%, transparent 60%),
    linear-gradient(145deg, #0b142d 0%, #16203f 100%)
  `,
          
      }}>
        {/* Logo réutilisé avec effet de glow */}
        <Logo 
          size={76} 
          variant="minimal" 
          showGlow={true}
        />
        <h1 style={{ color: 'white', marginTop: '1rem' }}>Yeldi</h1>
        <p style={{ color: 'rgba(255,255,255,0.85)' }}>Connectez-vous à votre espace commerçant</p>
      </div>

      <div className="auth-body">
        <h2 style={{ fontSize: '1.25rem', fontWeight: 800, marginBottom: '1.5rem', letterSpacing: '-0.3px' }}>
          Connexion
        </h2>

        {error && (
          <div className="alert alert-error" style={{ margin: '0 0 1.1rem' }}>
            <span>{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label className="form-label" htmlFor="l-email"><Mail size={12} strokeWidth={2.5}/>Adresse email</label>
            <div className="form-input-wrap">
              <Mail size={16} className="form-input-icon"/>
              <input id="l-email" className="form-input" type="email" value={email}
                onChange={e => setEmail(e.target.value.trim())} placeholder="votre@email.com"
                autoComplete="email" required/>
            </div>
          </div>

          <div className="form-group" style={{ marginBottom: 0 }}>
            <label className="form-label" htmlFor="l-pwd"><Lock size={12} strokeWidth={2.5}/>Mot de passe</label>
            <div style={{ position: 'relative' }}>
              <div className="form-input-wrap">
                <Lock size={16} className="form-input-icon"/>
                <input id="l-pwd" className="form-input" type={showPwd ? 'text' : 'password'} value={password}
                  onChange={e => setPassword(e.target.value)} placeholder="••••••••"
                  autoComplete="current-password" style={{ paddingRight: '3rem' }} required/>
              </div>
              <button type="button" onClick={() => setShowPwd(!showPwd)}
                aria-label={showPwd ? 'Masquer' : 'Afficher'}
                style={{ position: 'absolute', right: '0.75rem', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-2)', padding: '0.35rem', display: 'flex', alignItems: 'center' }}>
                {showPwd ? <EyeOff size={17}/> : <Eye size={17}/>}
              </button>
            </div>
          </div>

          <button type="submit" className="btn btn-primary btn-large" disabled={loading} style={{ marginTop: '0.5rem' }}>
            {loading ? 'Connexion en cours…' : <><LogIn size={18}/>Se connecter</>}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '1.75rem', color: 'var(--text-2)', fontSize: '0.88rem' }}>
          Pas encore de compte ?{' '}
          <Link to="/register" style={{ color: 'var(--primary)', fontWeight: 700, textDecoration: 'none' }}>
            S'inscrire gratuitement
          </Link>
        </div>

        <button onClick={() => navigate('/')} className="btn btn-ghost btn-large" style={{ marginTop: '0.85rem' }}>
          Continuer sans compte <ArrowRight size={16}/>
        </button>
      </div>
    </div>
  );
};

export default Login;